import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from 'primeng/tooltip';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';

@Component({
  selector: 'gc-fp-open-custom-correlation-action',
  standalone: true,
  imports: [ButtonModule, SvgIconComponent, TranslatePipe, TranslateDirective, Tooltip],
  templateUrl: './fp-open-custom-correlation-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpOpenCustomCorrelationActionComponent {
  public readonly scrRes = inject(ScreenResolutionService);
  public isLabelHidden = input<boolean>(false);

  public openCustomCorrelationPopup() {
    console.log('Open custom correlation popup');
  }
}
